import React, { Component } from 'react';
import { Route } from "react-router-dom";
import SideBar from './SideBar';
import { _setTime } from './Function';
import PaymentList from "./Payment.List";
import PaymentItem from "./Payment.Item";

class Payment extends Component{

    constructor() {
        super();
        this.state = {}
    }

    onAddTime = () => { _setTime() }

    render() {
        return (
            <div className="fix-content content-bar-bigger" onClick={(e) => this.onAddTime()}>
                <SideBar onRefresh={false} />
                <div className="content-bar">
                    <Route exact path="/online/payment/:year?" defual component={PaymentList} />
                    <Route path="/online/payment/month/:month/:year" component={PaymentItem} />

                </div>
            </div>
        );
    }

}
export default Payment;
